const videoSections = document.querySelectorAll('.section--video');

videoSections.forEach(videoSection => {
    const video = videoSection.querySelector('video');
    const button = videoSection.querySelector('.video__btn--play');

    button.addEventListener("click", function () {
        if (video.paused) {
            video.play();
            setTimeout(() => {
                button.classList.remove('video__btn--play');
                button.classList.add('video__btn--pause');
            }, 100);
        } else {
            video.pause();
            setTimeout(() => {
                button.classList.remove('video__btn--pause');
                button.classList.add('video__btn--play');
            }, 100);
        }
    });

    // Show the play button again when the video is paused by other means
    video.addEventListener("pause", function () {
        setTimeout(() => {
            button.classList.remove('video__btn--pause');
            button.classList.add('video__btn--play');
        }, 100);
    });

    // Hide the play button when the video is playing
    video.addEventListener("play", function () {
        setTimeout(() => {
            button.classList.remove('video__btn--play');
            button.classList.add('video__btn--pause');
        }, 100);
    });
});
